import { useMemo } from 'react';
import { ComboboxItem } from '@screentone/core';

import {
  AllessehQuerySortKeyTypes,
  AllessehQuerySortOrderType,
  useAllessehContentQuery
} from './useAllessehContentQuery';

const DAYS_AGO = 365;

export const useAllessehProductAggregations = () => {
  const daysAgo = useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() - DAYS_AGO);
    return d.toISOString();
  }, []);

  const query = useAllessehContentQuery({
    query: {
      and: [{ date: { key: 'LiveDate', value: daysAgo, operand: 'Greater' } }]
    },
    sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }],
    count: 1,
    aggregations: ['Product']
  });

  const items = useMemo<ComboboxItem[]>(
    () =>
      (query.data?.pages[0]?.meta?.aggregations[0]?.values ?? []).map((v: { value: string }) => ({
        id: v.value,
        value: v.value,
        label: v.value
      })),
    [query.data]
  );

  return { items, isLoading: query.isLoading };
};
